module.exports = __webpack_public_path__ + "media/images/front/brands/atelier/atelier_header_m-26e0e7178821ceb7495329cfd61840a1.webp";